<template>
  <div>
    <section class="category">
      <div class="category-head">
        <div class="category-left">
          <h3 class="category-title">{{ title }}</h3>
          <span class="multi-labal">※複数選択可</span>
        </div>
        <div class="category-right">
          <label class="checkbox">
            <input
              class="checkbox-input"
              type="checkbox"
              :name="storeKey"
              :checked="isAllChecked"
              @click="handleAllCheckClicked"
            />
            <div class="checkbox-title">すべて選択</div>
          </label>
        </div>
      </div>
      <ul class="list">
        <li class="list-item" v-for="(value, key) in form" :key="key">
          <Checkbox
            :label="value.label"
            :value="key"
            :storeKey="storeKey"
            :eventId="`${analyticsPrefix}_${value.scid}`"
          />
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Checkbox from "./Checkbox.vue";
import { adobeClickEvent } from "../../../modules/analytics";
export default {
  name: "CheckboxSection",
  components: {
    Checkbox,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    analyticsPrefix: {
      type: String,
      default: "",
    },
    storeKey: {
      type: String,
      default: "",
    },
    form: {
      type: Object,
      default: () => ({
        "01": { label: "", values: [], scid: "" },
      }),
    },
  },
  computed: {
    ...mapGetters("selectedFormIds", ["selectedLists"]),
    checkedArray() {
      return this.selectedLists[this.storeKey];
    },
    isAllChecked() {
      return Object.keys(this.form).length === this.checkedArray.length;
    },
  },
  methods: {
    analyze() {
      adobeClickEvent(`${this.analyticsPrefix}_all`);
    },
    handleAllCheckClicked() {
      this.analyze();
      if (this.isAllChecked) {
        this.checkOutAllBox();
      } else {
        this.checkAllBox();
      }
    },
    checkAllBox() {
      const allIds = Object.keys(this.form);
      this.$store.dispatch("selectedFormIds/setCheckboxValue", {
        value: allIds,
        target: this.storeKey,
      });
    },
    checkOutAllBox() {
      this.$store.dispatch("selectedFormIds/setCheckboxValue", {
        value: [],
        target: this.storeKey,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.category {
  width: 100%;

  .category-head {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .category-left {
    display: flex;
    align-items: center;
  }

  .category-title {
    text-align: left;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 1.7px;
  }

  .required-labal {
    display: block;
    border: 1px solid $main-red;
    color: $main-red;
    line-height: 1;
    padding: 2px;
    margin-left: 20px;
  }

  .multi-labal {
    display: block;
    line-height: 1;
    margin-left: 20px;
    font-size: 13px;
    font-weight: normal;
    position: relative;
    top: 1px;
  }

  .list {
    width: 100%;
    border-top: 1px solid #ddd;
    display: flex;
    flex-wrap: wrap;
    margin-top: 9px;
  }

  .list-item {
    margin: 20px 20px 0 0;
  }

  @include media() {
    .category-title {
      font-size: vw(12);
      letter-spacing: vw(0.8);
    }

    .required-labal {
      font-size: vw(10);
      margin-left: vw(10);
      padding: vw(3);
    }

    .multi-labal {
      margin-left: vw(10);
      font-size: vw(11);
      top: vw(1);
      /* top: 1px; */
    }

    .list {
      margin-top: vw(5);
      justify-content: space-between;
    }

    .list-item {
      width: 48%;
      margin: vw(15) 0 0 0;
    }
  }
}

/* .checkbox {
  width: 100%;
  position: relative;

  .checkbox-input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;

    &:checked + .checkbox-title {
      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 11px;
        height: 13px;
        background: url("../../../assets/images/_parts/other/check.svg")
          no-repeat center/contain;
        left: 5px;
        top: -1px;
      }
    }
  }

  .checkbox-title {
    display: flex;
    position: relative;
    align-items: center;
    width: 100%;
    height: 100%;
    line-height: 1.2;
    cursor: pointer;

    &::before {
      $size: 15px;
      content: "";
      position: relative;
      top: 0px;
      display: block;
      margin-right: 5px;
      width: $size;
      height: $size;
      border-radius: 3px;
      background-color: #fff;
      border: 1px solid #dddddd;
      flex-shrink: 0;
    }
  }

  @include media() {
    .checkbox-input {
      &:checked + .checkbox-title {
        &::after {
          width: vw(9);
          height: vw(11);
          left: vw(5);
          top: 0px;
        }
      }
    }

    .checkbox-title {
      line-height: 1.2;
      align-items: flex-start;
      font-size: vw(11);

      &::before {
        $size: vw(13);
        top: 0; //vw(1);
        margin-right: vw(8);
        width: $size;
        height: $size;
        border-radius: vw(3);
      }
    }
  }
} */
</style>
